import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatInteger(value, fallback = '0') {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return fallback;
  return String(Math.round(numericValue));
}

export function formatEuroAmount(value, options = {}) {
  const { suffix = '€', fallback = '0' } = options;
  return `${formatInteger(value, fallback)}${suffix}`;
}

export function formatDateDDMMYYYY(value, fallback = '-') {
  if (!value) return fallback;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
